<template>
  <el-table-column
    prop="invoice.status"
    label="Paid"
    width="100"
    header-align="center"
    align="center"
  >
    <template #header="{ column }">
      <div style="position: relative; width: 100%; height: 100%">
        <div
          style="
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            cursor: pointer;
          "
          @click="handlePaidHeaderClick"
        ></div>
        <div style="text-align: center">{{ column.label }}</div>
      </div>
    </template>
    <template #default="scope">
      <InvoiceStatusCell :scope="scope" />
    </template>
  </el-table-column>
</template>

<script setup>
import { ref } from "vue";
import { useTable } from "@/stores";
import InvoiceStatusCell from "./InvoiceStatusCell.vue";

const tableStore = useTable();
const currentSortOrder = ref(0);

const handlePaidHeaderClick = () => {
  currentSortOrder.value = (currentSortOrder.value + 1) % 5;

  const sortOrders = [
    ["", "unpaid", "paid", "claimed paid", "claimed internal"],
    ["unpaid", "paid", "claimed paid", "claimed internal", ""],
    ["paid", "claimed paid", "claimed internal", "", "unpaid"],
    ["claimed paid", "claimed internal", "", "unpaid", "paid"],
    ["claimed internal", "", "unpaid", "paid", "claimed paid"],
  ];

  const currentOrder = sortOrders[currentSortOrder.value];

  const sortedData = [...tableStore.sortedTableData].sort((a, b) => {
    const statusA = a.invoice?.status || "";
    const statusB = b.invoice?.status || "";
    return currentOrder.indexOf(statusA) - currentOrder.indexOf(statusB);
  });
  tableStore.setTableData(sortedData);
};
</script>
